import React from "react";

const DisplayContext = React.createContext({
  fullscreen: false,
  toggleFullscreen: () => {},
});
DisplayContext.displayName = "DisplayContext";

export default DisplayContext;
